import { createContext } from 'react';

import { type DiceGameCardRewardType } from '@/common/types/components';

interface RewardToDestroyType {
  kind: 'Resource' | 'Cash' | 'Material' | 'Product';
  rewards: Partial<Record<DiceGameCardRewardType, number>>;
}

const DiceGameModalsContext = createContext(
  {} as {
    isRechargeEnergyOpen: boolean;
    openRechargeEnergy: () => void;
    closeRechargeEnergy: () => void;
    isBombEventActive: boolean;
    openBombEvent: () => void;
    closeBombEvent: () => void;
    isGameOverEventActive: boolean;
    openGameOverEvent: () => void;
    closeGameOverEvent: () => void;
  },
);

export { DiceGameModalsContext, type RewardToDestroyType };
